<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Многофункционален продукт MB2236">
     Многофункционален продукт MB2236
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_bg" title="Информация за безопасност">
     Информация за безопасност
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Правила">
      Правила
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Извлечения за продукта">
      Извлечения за продукта
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_bg" title="Научете повече за принтера">
     Научете повече за принтера
    </a>
   </p>
   <div id="divd0e172">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_bg" title="Откриване на информация за принтера">
      Откриване на информация за принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_bg" title="Намиране на серийния номер на принтера">
      Намиране на серийния номер на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-model-topic.html#configured-model_bg" title="Конфигурация на принтера">
      Конфигурация на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-group.html#d0e379" title="Използване на контролния панел">
      Използване на контролния панел
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_bg" title="Персонализиране на началния екран">
      Персонализиране на началния екран
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_bg" title="Промяна на езика на екранната клавиатура">
      Промяна на езика на екранната клавиатура
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_bg" title="Запознаване със състоянията на бутона за захранване и индикаторната светлина">
      Запознаване със състоянията на бутона за захранване и индикаторната светлина
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e759" title="Избор на хартия">
      Избор на хартия
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_bg" title="Настройване, инсталиране и конфигуриране">
     Настройване, инсталиране и конфигуриране
    </a>
   </p>
   <div id="divd0e1623">
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_bg" title="Избор на място за принтера">
      Избор на място за принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_bg" title="Свързване на кабели">
      Свързване на кабели
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1818" title="Настройване на принтера за изпращане на факс">
      Настройване на принтера за изпращане на факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_bg" title="Конфигуриране на SMTP настройките за имейл">
      Конфигуриране на SMTP настройките за имейл
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-paper-and-specialty-media-group.html#d0e3751" title="Зареждане на хартия и специални носители">
      Зареждане на хартия и специални носители
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3884" title="Инсталиране и актуализация на софтуер, драйвери и фърмуер">
      Инсталиране и актуализация на софтуер, драйвери и фърмуер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4117" title="Работа в мрежа">
      Работа в мрежа
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_bg" title="Създаване на профил в Cloud Connector">
      Създаване на профил в Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_bg" title="Печат на страница с настройки на менюто">
      Печат на страница с настройки на менюто
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_bg" title="Защита на принтера">
     Защита на принтера
    </a>
   </p>
   <div id="divd0e4635">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_bg" title="Изтриване на паметта на принтера">
      Изтриване на паметта на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_bg" title="Възстановяване на фабричните настройки по подразбиране">
      Възстановяване на фабричните настройки по подразбиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_bg" title="Изявление за енергозависимост">
      Изявление за енергозависимост
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_bg" title="Печат">
     Печат
    </a>
   </p>
   <div id="divd0e4757">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_bg" title="Отпечатване от компютър">
      Отпечатване от компютър
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4783" title="Отпечатване от мобилно устройство">
      Отпечатване от мобилно устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_bg" title="Отпечатване от флаш устройство">
      Отпечатване от флаш устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_bg" title="Поддържани флаш устройства и типове файлове">
      Поддържани флаш устройства и типове файлове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_bg" title="Конфигуриране на поверителни задания">
      Конфигуриране на поверителни задания
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_bg" title="Отпечатване на конфиденциални и други изчакващи задания за печат">
      Отпечатване на конфиденциални и други изчакващи задания за печат
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_bg" title="Отпечатване от профил в Cloud Connector">
      Отпечатване от профил в Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_bg" title="Отпечатване на списък с примери на шрифтове">
      Отпечатване на списък с примери на шрифтове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_bg" title="Поставяне на разделителни листове между копията">
      Поставяне на разделителни листове между копията
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_bg" title="Отмяна на задание за печат">
      Отмяна на задание за печат
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_bg" title="Регулиране на тъмнотата на тонера">
      Регулиране на тъмнотата на тонера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_bg" title="Копиране">
     Копиране
    </a>
   </p>
   <div id="divd0e5379">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_bg" title="С помощта на автоматичното подаващо устройство и стъклото на скенера">
      С помощта на автоматичното подаващо устройство и стъклото на скенера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_bg" title="Правене на копия">
      Правене на копия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_bg" title="Копиране на снимки">
      Копиране на снимки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-letterhead-topic.html#copying-letterhead_bg" title="Копиране върху бланка">
      Копиране върху бланка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_bg" title="Копирайте от двете страни на хартията">
      Копирайте от двете страни на хартията
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_bg" title="Намаляване или увеличаване на копията">
      Намаляване или увеличаване на копията
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_bg" title="Копиране на няколко страници върху един лист">
      Копиране на няколко страници върху един лист
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_bg" title="Сортиране на копия">
      Сортиране на копия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_bg" title="Копиране на карти">
      Копиране на карти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_bg" title="Създаване на бърза команда за копиране">
      Създаване на бърза команда за копиране
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_bg" title="Имейл">
     Имейл
    </a>
   </p>
   <div id="divd0e5709">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_bg" title="С помощта на автоматичното подаващо устройство и стъклото на скенера">
      С помощта на автоматичното подаващо устройство и стъклото на скенера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_bg" title="Изпращане на имейл">
      Изпращане на имейл
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_bg" title="Факс">
     Факс
    </a>
   </p>
   <div id="divd0e5824">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_bg" title="С помощта на автоматичното подаващо устройство и стъклото на скенера">
      С помощта на автоматичното подаващо устройство и стъклото на скенера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_bg" title="Изпращане на факс">
      Изпращане на факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#sending-fax-scheduled-time_bg" title="Насрочване на факс">
      Насрочване на факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_bg" title="Създаване на бърза команда за факсово местоназначение">
      Създаване на бърза команда за факсово местоназначение
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_bg" title="Намаляване на разделителната способност на факса">
      Намаляване на разделителната способност на факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_bg" title="Регулиране на тъмнината на факса">
      Регулиране на тъмнината на факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_bg" title="Печат на дневник на факсове">
      Печат на дневник на факсове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_bg" title="Блокиране на нежелани факсове">
      Блокиране на нежелани факсове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_bg" title="Задържане на факсове">
      Задържане на факсове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_bg" title="Препращане на факс">
      Препращане на факс
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_bg" title="Сканиране">
     Сканиране
    </a>
   </p>
   <div id="divd0e6218">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_bg" title="С помощта на автоматичното подаващо устройство и стъклото на скенера">
      С помощта на автоматичното подаващо устройство и стъклото на скенера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_bg" title="Сканиране към компютър">
      Сканиране към компютър
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_bg" title="Сканиране към флаш устройство">
      Сканиране към флаш устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_bg" title="Сканиране към FTP сървър">
      Сканиране към FTP сървър
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_bg" title="Сканиране към мрежова папка">
      Сканиране към мрежова папка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_bg" title="Сканиране към профил в Cloud Connector">
      Сканиране към профил в Cloud Connector
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_bg" title="Използване на менютата на принтера">
     Използване на менютата на принтера
    </a>
   </p>
   <div id="divd0e6565">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_bg" title="Карта на менюто">
      Карта на менюто
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6913" title="Устройство">
      Устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8549" title="Печат">
      Печат
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9342" title="Хартия">
      Хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e9643" title="Копиране">
      Копиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e9865" title="Факс">
      Факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e11487" title="Имейл">
      Имейл
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12170" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e12602" title="USB у-во">
      USB у-во
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13207" title="Мрежа/портове">
      Мрежа/портове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15222" title="Защита">
      Защита
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_bg" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e15936" title="Отчети">
      Отчети
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_bg" title="Откриване и отстраняване на неизправности">
      Откриване и отстраняване на неизправности
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_bg" title="Поддръжка на принтера">
     Поддръжка на принтера
    </a>
   </p>
   <div id="divd0e16228">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_bg" title="Проверка на състоянието на части и консумативи">
      Проверка на състоянието на части и консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_bg" title="Конфигуриране на известия за консумативи">
      Конфигуриране на известия за консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_bg" title="Конфигуриране на уведомления с имейл">
      Конфигуриране на уведомления с имейл
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_bg" title="Преглед на отчетите">
      Преглед на отчетите
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_bg" title="Поръчване на части и консумативи">
      Поръчване на части и консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e16501" title="Замяна на части и консумативи">
      Замяна на части и консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e16646" title="Почистване на частите на принтера">
      Почистване на частите на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16734" title="Пестене на енергия и хартия">
      Пестене на енергия и хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_bg" title="Преместване на принтера в друго местоположение">
      Преместване на принтера в друго местоположение
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_bg" title="Транспортиране на принтера">
      Транспортиране на принтера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_bg" title="Отстраняване на проблем">
     Отстраняване на проблем
    </a>
   </p>
   <div id="divd0e16895">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_bg" title="Проблеми с качеството на печата">
      Проблеми с качеството на печата
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e17006" title="Проблеми с печата">
      Проблеми с печата
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_bg" title="Принтерът не отговаря">
      Принтерът не отговаря
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_bg" title="Не може да разчете флаш устройството">
      Не може да разчете флаш устройството
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_bg" title="Разрешаване на USB порт">
      Разрешаване на USB порт
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19613" title="Проблеми с мрежовата връзка">
      Проблеми с мрежовата връзка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19831" title="Проблеми с консумативите">
      Проблеми с консумативите
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_bg" title="Отстраняване на заседнала хартия">
      Отстраняване на заседнала хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_bg" title="Проблеми с подаването на хартия">
      Проблеми с подаването на хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20609" title="Проблеми с изпращането на имейли">
      Проблеми с изпращането на имейли
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e20728" title="Проблеми с работата на факса">
      Проблеми с работата на факса
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21383" title="Проблеми със сканирането">
      Проблеми със сканирането
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_bg" title="Свързване с поддръжка на клиенти">
      Свързване с поддръжка на клиенти
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_bg" title="Преработване и изхвърляне">
     Преработване и изхвърляне
    </a>
   </p>
   <div id="divd0e22138">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_bg" title="Рециклиране на продукти на Lexmark">
      Рециклиране на продукти на Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_bg" title="Рециклиране на опаковки на Lexmark">
      Рециклиране на опаковки на Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_bg" title="Известия">
     Известия
    </a>
   </p>
   <div id="divd0e22173">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22176" title="Информация за продукта">
      Информация за продукта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22193" title="Известие за нова версия">
      Известие за нова версия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_bg" title="Търговски марки">
      Търговски марки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_bg" title="Известия за лицензиране">
      Известия за лицензиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_bg" title="Нива на емисии на шум">
      Нива на емисии на шум
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_bg" title="Директива относно отпадъци от електрическо и електронно оборудване (WEEE)">
      Директива относно отпадъци от електрическо и електронно оборудване (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22299" title="Литиевойонна презареждаема батерия">
      Литиевойонна презареждаема батерия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_bg" title="Регламент (ЕС) 2023/1542">
      Регламент (ЕС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22337" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_bg" title="Изхвърляне на продукта">
      Изхвърляне на продукта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_bg" title="Връщане на касетите на Lexmark за повторна употреба или рециклиране">
      Връщане на касетите на Lexmark за повторна употреба или рециклиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_bg" title="Известие за чувствителност към статично електричество">
      Известие за чувствителност към статично електричество
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_bg" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_bg" title="Информация за температурата">
      Информация за температурата
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_bg" title="Известие за лазера">
      Известие за лазера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_bg" title="Потребление на енергия">
      Потребление на енергия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_bg" title="Нормативни разпоредби, касаещи оборудване за телекомуникационни терминали">
      Нормативни разпоредби, касаещи оборудване за телекомуникационни терминали
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22596" title="Нормативни разпоредби за безжични продукти">
      Нормативни разпоредби за безжични продукти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_bg" title="Известие за модулен компонент">
      Известие за модулен компонент
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_bg" title="Излагане на радиочестотно лъчение">
      Излагане на радиочестотно лъчение
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22621" title="Съответствие с директиви на Европейската общност (ЕО)">
      Съответствие с директиви на Европейската общност (ЕО)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_bg" title="Съответствие с директиви на Европейската общност (ЕО)">
      Съответствие с директиви на Европейската общност (ЕО)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue